/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 16:55:04
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 09:51:45
 * @name: 通讯录-搜索
 * @Description: 通讯录-搜索
 * @FilePath: \project\src\module\department\validator\search.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'search',
    description: '搜索内容',
    required: true,
    required_message: '搜索内容为必传项',
    require_toast: true,
    match: (e) => {
      return '';
    }
  },
]